export const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const LAWTON_FALLBACK_LOGO = 'https://component.mediassist.in/cdn/mayfair/LawtonAsia.jpeg';